import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithWithdraws from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithWithdraws'
import PlayerWithWithdrawListing from '@/modules/manage-player/components/PlayerWithWithdraw/components/PlayerWithWithdrawListing'

type SortOrder = 'asc' | 'desc' | undefined

function PlayerWithWithdrawDirectPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [withdrawAmountSort, setWithdrawAmountSort] =
		useState<SortOrder>('desc')
	const [withdrawTimeSort, setWithdrawTimeSort] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalWithdrawAmount') {
			setWithdrawAmountSort(order)
			setWithdrawTimeSort(undefined)
		} else if (columnId === 'totalWithdrawTime') {
			setWithdrawTimeSort(order)
			setWithdrawAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		withdrawAmountSort,
		withdrawTimeSort,
	}

	const { data, isLoading } = useQueryGetPlayerWithWithdraws(payload)

	return (
		<PageContainer>
			<PlayerWithWithdrawListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
				showBackButton={false}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithWithdrawDirectPage = withUserPermission(
	PlayerWithWithdrawDirectPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithWithdrawDirectPage
